import {CHAT_ANSWER, CHAT_MESSAGE} from '../actions/chat'

const initialState = {
  question: 0,
  order: [],
  answers: {},
  timestamps: {}
}

function chatReducer(state = initialState, action) {
  switch (action.type) {
    case CHAT_ANSWER:
      return {
        ...state,
        question: state.question + 1,
        order: state.order.concat(action.question),
        answers: {
          ...state.answers,
          [action.question]: action.answer
        }
      }
    case CHAT_MESSAGE:
      return {
        ...state,
        timestamps: {
          ...state.timestamps,
          [action.question]: action.time
        }
      }
    default:
      return state
  }
}

export default chatReducer



// WEBPACK FOOTER //
// ./reducers/chat.js